"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdNumberErrorMessage = exports.IdNumberErrorCode = void 0;
var IdNumberErrorCode;
(function (IdNumberErrorCode) {
    IdNumberErrorCode["ID_NUMBER_INVALID"] = "ID_NUMBER_INVALID";
    IdNumberErrorCode["ID_NUMBER_INVALID_CONTROL_ONE"] = "ID_NUMBER_INVALID_CONTROL_ONE";
    IdNumberErrorCode["ID_NUMBER_INVALID_CONTROL_TWO"] = "ID_NUMBER_INVALID_CONTROL_TWO";
    IdNumberErrorCode["ID_NUMBER_INVALID_DATE"] = "ID_NUMBER_INVALID_DATE";
})(IdNumberErrorCode || (exports.IdNumberErrorCode = IdNumberErrorCode = {}));
var IdNumberErrorMessage;
(function (IdNumberErrorMessage) {
    IdNumberErrorMessage["ID_NUMBER_INVALID"] = "Id-nummer m\u00E5 v\u00E6re 11 siffer og v\u00E6re p\u00E5 gyldig format.";
    IdNumberErrorMessage["ID_NUMBER_INVALID_CONTROL_ONE"] = "Feil oppdaget i kontrollgruppe 1";
    IdNumberErrorMessage["ID_NUMBER_INVALID_CONTROL_TWO"] = "Feil oppdaget i kontrollgruppe 2";
    IdNumberErrorMessage["ID_NUMBER_INVALID_DATE"] = "Id-nummer har ugyldig f\u00F8delsdato";
})(IdNumberErrorMessage || (exports.IdNumberErrorMessage = IdNumberErrorMessage = {}));
//# sourceMappingURL=types.js.map